import './App.css';
import Form from './Form';
import Header from './Header';
import Footer from './Footer';

function App() {

  return (
    <div className="App">
      <Header/>
      <Form/>
      <Footer/>
    </div>
  );
}

export default App;
